import { Button } from '@mui/material';
import { usePriorAppraisal } from '@/queries/useAppraisalDetail';

interface ViewPriorEvaluationButtonProps {
  appraisalId: string;
}

export function ViewPriorEvaluationButton({ appraisalId }: ViewPriorEvaluationButtonProps) {
  const { data, isLoading } = usePriorAppraisal(appraisalId);

  const priorAppraisalId = data?.appraisalId ?? null;

  const handleClick = () => {
    if (priorAppraisalId != null) {
      window.open(`/appraisals/${priorAppraisalId}`, '_blank');
    }
  };

  return (
    <Button
      variant="outlined"
      onClick={handleClick}
      disabled={!priorAppraisalId || isLoading}
    >
      View Prior Evaluation
    </Button>
  );
}
